import { useEffect } from "react";
import { useAuth } from "@/context/AuthContext";
import { initPostHog, identifyUser, resetPostHog, isPostHogEnabled } from "@/lib/posthog";

/**
 * Zero-UI bridge: boots PostHog on mount (no-op when REACT_APP_POSTHOG_KEY
 * is missing) and identifies / resets on auth state changes. Mounted once
 * inside <AuthProvider/> so it can read the user without touching the
 * protected AuthContext file.
 */
export default function PostHogBridge() {
  const { user } = useAuth();

  useEffect(() => { initPostHog(); }, []);

  useEffect(() => {
    if (!isPostHogEnabled()) return;
    if (user) identifyUser(user);
    else resetPostHog();
  }, [user]);

  return null;
}
